$( function ()
{
    $.widget( "ui.ShareLink",
    {
        options:
        {
        },
        _destroy: function ()
        {
            return undefined;
        },

        _init: function ()
        {
            return undefined;
        },

        _create: function ()
        {
            var self = this, jElement = $( this.element );

            jElement.find( '.vp_show_share_button' ).click( function ()
            {
                self.toggleMainPanel();
                self.hidePrintPanel();
            } );

            jElement.find( '.vp_social_close_button' ).click( function ( e )
            {
                self.hideMainPanel();
                jElement.find( '.vp_show_share_button' ).focus();
            });

            jElement.find( '.printlang_container .vp_lang_selection' ).click( function ()
            {
                self.togglePrintPanel();
                self.hideMainPanel();
            } );

            jElement.find( '.vp_print_close_button' ).click( function ( e )
            {
                self.hidePrintPanel();
                jElement.find( '.vp_lang_selection' ).focus();
            } );

            jElement.find( ".vp_share_link_text" ).click( function ( e )
            {
                this.setSelectionRange( 0, this.value.length );
            });

            jElement.on(
                'change',
                '.print_panel select',
                function (aEvent)
                {
                    var lSuperContainer = $(aEvent.target).parents('.vp_share_panel');
                    var lLink = lSuperContainer.find('a.vp_print_print_button');
                    var lSelection = lSuperContainer.find('.print_panel select option:selected').val();
                    var lNeedsReset = true;
                    if (lLink.data('originalhref') === undefined)
                    {
                        lLink.data('originalhref', lLink.attr('href'));
                        lNeedsReset = false;
                    }
                    if (lSelection === 'en')
                    {
                        if (lNeedsReset === true)
                        {
                            lLink.attr('href', lLink.data('originalhref'));
                        }
                    }
                    else
                    {
                        var lEncodedUri = lLink.data('printuri');
                        var lNewLink = `https://translate.google.com/translate?u=${lEncodedUri}&tl=${lSelection}`
                        lLink.attr('href', lNewLink);
                    }
                }
            );
        },

        toggleMainPanel: function() 
        {
            if ( this.isMainPanelHidden() )
            {
                this.showMainPanel();
            }
            else
            {
                this.hideMainPanel();
            }
        },

        togglePrintPanel: function() 
        {
            if ( this.isPrintPanelHidden() )
            {
                this.showPrintPanel();
            }
            else
            {
                this.hidePrintPanel();
            }
        },

        isMainPanelHidden: function ()
        {
            return $( this.element ).find( '.main_panel' ).hasClass( 'hidden' );
        },

        showMainPanel: function ()
        {
            $( '.vp_share_panel .main_panel' ).addClass( 'hidden' );
            $( this.element ).find( '.main_panel' ).removeClass( 'hidden' );
        },

        hideMainPanel: function ()
        {
            var jElement = $( this.element );
            jElement.find( '.main_panel' ).addClass( 'hidden' );
        },

        isPrintPanelHidden: function ()
        {
            return $( this.element ).find( '.print_panel' ).hasClass( 'hidden' );
        },

        showPrintPanel: function ()
        {
            $( '.vp_share_panel .print_panel' ).addClass( 'hidden' );
            $( this.element ).find( '.print_panel' ).removeClass( 'hidden' );
        },

        hidePrintPanel: function ()
        {
            var jElement = $( this.element );
            jElement.find( '.print_panel' ).addClass( 'hidden' );
        }
    } );

    $( '.vp_share_panel' ).ShareLink( {} );
} );